import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from 'lodash';
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import useWindowDimensions from "../../../../../../../../hooks/useWindowsDimensions";
import { useEffect, useState } from "react";
import { selectQuotesListItems } from "../../../../../../../../redux/quotes/selector";
import storePersist from "../../../../../../../../redux/storePersist";
import { quotes } from "../../../../../../../../redux/quotes/action";
import PageLoader from "../../../../../../../../components/PageLoader";
import MobileViewTable from "../../../../../../../../common/components/mobile-view-table.component";
import InfiniteScroll from "react-infinite-scroll-component";

const CustomerQuotesMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [index, setIndex] = useState(1)
  const [hasMore, setHasMore] = useState();
  const [rawData, setRawData] = useState<any>([])
  const [quoteData, setQuoteData] = useState<any>([])
  const itemsData = useSelector(selectQuotesListItems)
  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'Logistics_Customer']);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.category_name', headerName: 'Category Name', sortable: true, filter: true, search: true },
      { field: 'Message.quotePrice', headerName: 'Quote price', isCurrencyValueFormat: true },
      { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }

  const fetchQuotes = async (_page: any, size: any) => {
    await dispatch(quotes.resetAction({ actionType: 'list' }))
    await dispatch(quotes.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`, entity: 'quotes', jsonData: {
        "PageNumber": _page,
        "PageSize": size,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "CustomerId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }))
  }
  useEffect(() => {
    if (index > 1) {
      createColumnDefs()
      fetchQuotes(index, 10)
    }

  }, [index])

  useEffect(() => {
    createColumnDefs()
    fetchQuotes(index, 10)
  }, [])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const fetchMoreData = () => {
    const prevIndex = index
    setIndex(prevIndex + 1);
  };

  useEffect(() => {
    if (itemsData?.result?.items) {
      setRawData(itemsData?.result?.items)
      setHasMore(itemsData?.result?.pagination?.HasNextPage)
    }
  }, [itemsData]);

  const handleSearch = async (data: any) => {

    const searchCriteria = [{
      FieldName: "category_name",
      FieldText: "category_name",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
    await setQuoteData([])
    await dispatch(quotes.resetAction({ actionType: 'list' }))
    dispatch(quotes.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`, entity: 'quotes', jsonData: {
        "PageNumber": index,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
        "Filters": [
          {
            "FieldName": "CustomerId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }));
  }

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload cards</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlereload(),
    }
  ];

  const handlereload = async () => {
    await setQuoteData([])
    await fetchQuotes(index, 10)
  }

  useEffect(() => {
    let formatedData = []
    rawData.map((data: any) => {
      formatedData.push({
        Context: data?.Context,
        Message: {
          Id: data?.Message?.Id,
          category_name: data?.Message?.category_name,
          quotePrice: data?.Message.quote.price.value,
          CreatedOnUtc: data?.Message?.CreatedOnUtc,
          ModifiedOnUtc: data?.Message?.ModifiedOnUtc,
        }
      })
    })
    if (index > 1) {
      setQuoteData([...quoteData, ...formatedData])
    } else {
      setQuoteData(formatedData)
    }

  }, [rawData])

  return (
    <>
      {itemsData?.isLoading && index == 1 ? <PageLoader />
        :
        <MobileViewTable
          dataLength={quoteData.length}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          onSearch={handleSearch}
          additionButtons={additionButtons}
          columnData={columnDefs}
          rowData={quoteData}
          onEdit={handleEdit}
          headingName="Quotes" />

      }
    </>

  );
};

export default CustomerQuotesMobile;


